export const createDashboardRoute = (): string => {
  return '/dashboard';
};

export const createDashboardDetailRoute = (
  installationId: number,
  controllerId: number,
): string => {
  return `/installation/${installationId}/controller/${controllerId}`;
};

export const createBackofficeRoute = (): string => {
  return '/backoffice';
};

export const createUsersRoute = (): string => {
  return '/backoffice/users';
};

export const createAddUserRoute = (): string => {
  return '/backoffice/users/add';
};

export const createMonitoringRoute = (): string => {
  return '/backoffice/monitoring';
};

export const createInstallationRoute = (): string => {
  return '/backoffice/installation';
};

export const createPermissionRoute = (): string => {
  return '/backoffice/permission';
};

export const createOverviewRoute = (): string => {
  return '/backoffice/overview';
};

export const createLoginRoute = (): string => {
  return '/login';
};

export const createForbiddenRoute = (): string => {
  return '/forbidden';
};
